  <p-confirmDialog />

  <div *ngIf="isPageDragOver" class="page-drag-overlay">
    <div class="page-drag-inner">
      <i class="pi pi-cloud-upload page-drag-icon"></i>
      <span class="page-drag-label">{{ 'arquivos.uploadDropHint' | transloco }}</span>
    </div>
  </div>
  <div class="arquivos-page">
    <div class="header-tabs">
      <div class="tab">{{ 'arquivos.title' | transloco }}</div>
      <p-button
        icon="pi pi-upload"
        [label]="'arquivos.uploadBtn' | transloco"
        severity="danger"
        [raised]="true"
        styleClass="upload-btn"
        (onClick)="openUploadDialog()"
      ></p-button>
    </div>
    <div *ngIf="loading" class="loading-wrapper">
      <p-progressSpinner [style]="{ width: '40px', height: '40px' }" strokeWidth="4"></p-progressSpinner>
    </div>
    <app-vcu-file-explorer
      *ngIf="!loading"
      [maps]="maps"
      [logs]="logs"
      [deletingIds]="deletingIds"
      [refreshing]="refreshing"
      (refreshRequested)="onRefresh()"
      (downloadFile)="onDownload($event)"
      (downloadSelected)="onDownloadMany($event)"
      (linkVcu)="onLinkVcu($event)"
      (renameFile)="onRename($event)"
      (moveSelected)="onMove($event)"
      (deleteFile)="onDelete($event)"
      (deleteSelected)="onDeleteMany($event)"
      (viewChannels)="onViewChannels($event)"
      (shareFile)="onShare($event)"
    ></app-vcu-file-explorer>
  </div>

  <p-dialog
    [header]="'arquivos.uploadHeader' | transloco"
    [(visible)]="uploadDialogVisible"
    [modal]="true"
    [draggable]="false"
    [closable]="!uploading"
    [style]="{ width: '90vw', 'max-width': '480px' }"
  >
    <div class="upload-dialog-body">
      <div class="upload-section">
        <label class="upload-label">{{ 'arquivos.uploadFile' | transloco }}</label>
        <input #uploadInput type="file" multiple accept=".ftlog,.ftml,.ftmap,.ftm" hidden (change)="onUploadFileSelected($event)" />

        <div *ngIf="!selectedUploadFiles.length"
             class="upload-dropzone"
             [class.is-uploading]="uploading"
             [class.drag-over]="isDragOver"
             (click)="!uploading && uploadInput.click()"
             (dragover)="onDragOver($event)"
             (dragleave)="onDragLeave($event)"
             (drop)="onDrop($event)">
          <i class="pi pi-cloud-upload upload-icon"></i>
          <span class="upload-placeholder">{{ 'arquivos.uploadDropHint' | transloco }}</span>
        </div>

        <div *ngIf="selectedUploadFiles.length" class="upload-files-list">
          <div *ngFor="let f of selectedUploadFiles; let i = index"
               class="upload-file-row"
               [class.is-current]="uploading && i === currentUploadIndex">
            <i class="pi upload-file-row-icon"
               [class.pi-map]="detectTypeFromExtension(f.name) === 'map'"
               [class.pi-file]="detectTypeFromExtension(f.name) === 'log'"></i>
            <div class="upload-file-row-info">
              <span class="upload-file-name">{{ f.name }}</span>
              <span class="upload-file-size">
                {{ formatBytes(f.size) }}
                · {{ (detectTypeFromExtension(f.name) === 'map' ? 'arquivos.uploadTypeMap' : 'arquivos.uploadTypeLog') | transloco }}
              </span>
            </div>
            <button *ngIf="!uploading" type="button" class="upload-file-row-remove" (click)="removeUploadFile(i)" [attr.aria-label]="'common.buttons.remove' | transloco">
              <i class="pi pi-times"></i>
            </button>
          </div>
          <button *ngIf="!uploading" type="button" class="upload-add-more" (click)="uploadInput.click()">
            <i class="pi pi-plus"></i>
            {{ 'arquivos.uploadAddMore' | transloco }}
          </button>
        </div>
      </div>

      <div class="upload-section" *ngIf="selectedUploadFiles.length">
        <label class="upload-label">{{ 'arquivos.uploadFolder' | transloco }}</label>
        <div class="upload-type-row">
          <div class="upload-type-item" (click)="!uploading && (folderChoice = 'root')">
            <p-radioButton name="folderChoice" value="root" [(ngModel)]="folderChoice" inputId="folderChoiceRoot" [disabled]="uploading" />
            <label for="folderChoiceRoot" class="upload-type-label">
              <i class="pi pi-home"></i>
              {{ 'arquivos.uploadFolderRoot' | transloco }}
            </label>
          </div>
          <div class="upload-type-item" *ngIf="availableFolders.length" (click)="!uploading && (folderChoice = 'existing')">
            <p-radioButton name="folderChoice" value="existing" [(ngModel)]="folderChoice" inputId="folderChoiceExisting" [disabled]="uploading" />
            <label for="folderChoiceExisting" class="upload-type-label">
              <i class="pi pi-folder"></i>
              {{ 'arquivos.uploadFolderExisting' | transloco }}
            </label>
          </div>
          <div class="upload-type-item" (click)="!uploading && (folderChoice = 'custom')">
            <p-radioButton name="folderChoice" value="custom" [(ngModel)]="folderChoice" inputId="folderChoiceCustom" [disabled]="uploading" />
            <label for="folderChoiceCustom" class="upload-type-label">
              <i class="pi pi-folder-plus"></i>
              {{ 'arquivos.uploadFolderOther' | transloco }}
            </label>
          </div>
        </div>

        <div *ngIf="folderChoice === 'existing'" class="folder-list">
          <div
            *ngFor="let folder of availableFolders; let i = index"
            class="folder-list-item"
            [class.selected]="selectedExistingFolder === folder"
            (click)="!uploading && (selectedExistingFolder = folder)"
          >
            <p-radioButton
              name="existingFolder"
              [value]="folder"
              [(ngModel)]="selectedExistingFolder"
              [inputId]="'existingFolder-' + i"
              [disabled]="uploading"
            />
            <label [for]="'existingFolder-' + i" class="folder-list-label">
              <i class="pi pi-folder"></i>
              <span class="folder-list-name">{{ folder }}</span>
            </label>
          </div>
        </div>

        <input
          *ngIf="folderChoice === 'custom'"
          pInputText
          type="text"
          [(ngModel)]="customFolderName"
          maxlength="100"
          [placeholder]="'arquivos.uploadFolderOtherPlaceholder' | transloco"
          [disabled]="uploading"
        />
      </div>

      <div class="upload-progress-wrapper" *ngIf="uploading">
        <div class="upload-progress-header">
          <span class="upload-progress-label">
            {{ 'arquivos.uploadingFileOf' | transloco : { '0': currentUploadIndex + 1, '1': selectedUploadFiles.length } }}
          </span>
        </div>
        <div class="upload-progress-row">
          <div class="upload-progress-track">
            <div class="upload-progress-fill" [style.width.%]="uploadProgress"></div>
          </div>
          <span class="upload-progress-text">{{ uploadProgress }}%</span>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        [label]="'common.buttons.cancel' | transloco"
        [text]="true"
        [disabled]="uploading"
        (onClick)="uploadDialogVisible = false"
      />
      <p-button
        [label]="'arquivos.uploadStart' | transloco"
        icon="pi pi-upload"
        severity="danger"
        [disabled]="!canStartUpload"
        [loading]="uploading"
        (onClick)="startUpload()"
      />
    </ng-template>
  </p-dialog>

  <p-dialog
    [header]="'arquivos.linkVcuHeader' | transloco"
    [(visible)]="linkVcuDialogVisible"
    [modal]="true"
    [style]="{ width: '90vw', 'max-width': '460px' }"
    [closable]="true"
  >
    <div *ngIf="linkVcuFile" class="link-vcu-dialog-body">
      <p class="link-vcu-file-label">
        {{ 'arquivos.fileLabel' | transloco }} <strong>{{ linkVcuFile.fileName }}</strong>
      </p>

      <div *ngIf="loadingVcus" class="link-vcu-loading">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4"></p-progressSpinner>
      </div>

      <div *ngIf="!loadingVcus && vcuList.length === 0" class="link-vcu-empty">
        {{ 'arquivos.noVcuPaired' | transloco }}
      </div>

      <div *ngIf="!loadingVcus && vcuList.length > 0" class="link-vcu-list">
        <div *ngFor="let vcu of vcuList" class="link-vcu-item" (click)="selectedVcuId = vcu.id">
          <p-radioButton
            name="vcuSelect"
            [value]="vcu.id"
            [(ngModel)]="selectedVcuId"
            [inputId]="'vcu-' + vcu.id"
          />
          <label [for]="'vcu-' + vcu.id" class="link-vcu-item-label">
            <span class="link-vcu-name">{{ vcu.nickname || vcu.serialNumber }}</span>
            <span class="link-vcu-serial" *ngIf="vcu.nickname">{{ vcu.serialNumber }}</span>
            <span class="link-vcu-model" *ngIf="vcu.modelDescription">{{ vcu.modelDescription }}</span>
          </label>
        </div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        [label]="'common.buttons.cancel' | transloco"
        [text]="true"
        (onClick)="linkVcuDialogVisible = false"
      />
      <p-button
        [label]="'common.buttons.save' | transloco"
        icon="pi pi-check"
        (onClick)="saveLinkVcu()"
        [disabled]="!selectedVcuId || savingLink"
        [loading]="savingLink"
      />
    </ng-template>
  </p-dialog>

  <p-dialog
    [header]="'arquivos.renameHeader' | transloco"
    [(visible)]="renameDialogVisible"
    [modal]="true"
    [style]="{ width: '90vw', 'max-width': '460px' }"
    [closable]="!renaming"
  >
    <div class="rename-dialog-body">
      <label class="upload-label" for="renameInput">{{ 'arquivos.renameLabel' | transloco }}</label>
      <div class="rename-field">
        <input id="renameInput" type="text" pInputText class="rename-input"
               [(ngModel)]="renameValue" [disabled]="renaming"
               (keyup.enter)="canConfirmRename && confirmRename()" />
        <!-- A extensão fica fora do campo: o usuário não a digita, e assim não há como
             trocá-la sem querer nem duplicá-la. -->
        <span class="rename-ext" *ngIf="renameExtension">{{ renameExtension }}</span>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <p-button [label]="'common.buttons.cancel' | transloco" [text]="true"
                [disabled]="renaming" (onClick)="renameDialogVisible = false" />
      <p-button [label]="'common.buttons.save' | transloco" [loading]="renaming"
                [disabled]="!canConfirmRename" (onClick)="confirmRename()" />
    </ng-template>
  </p-dialog>

  <p-dialog
    [header]="'arquivos.shareHeader' | transloco"
    [(visible)]="shareDialogVisible"
    [modal]="true"
    [draggable]="false"
    [dismissableMask]="true"
    [style]="{ width: '90vw', 'max-width': '520px' }"
  >
    <div class="rename-dialog-body">
      <p class="link-vcu-file-label" *ngIf="shareFileItem">
        {{ 'arquivos.fileLabel' | transloco }} <strong>{{ shareFileItem.fileName }}</strong>
      </p>

      <div *ngIf="sharing" class="link-vcu-loading">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4"></p-progressSpinner>
      </div>

      <ng-container *ngIf="shareLink">
        <div class="rename-field">
          <input type="text" pInputText class="rename-input" readonly
                 [value]="shareUrl" (focus)="$any($event.target).select()" />
          <p-button icon="pi pi-copy" [label]="'arquivos.shareCopy' | transloco"
                    (onClick)="copyShareUrl()" />
        </div>
        <p class="link-vcu-file-label">
          {{ 'arquivos.shareExpires' | transloco: { date: (shareLink.expiresAt | date: 'dd/MM/yyyy HH:mm') } }}
        </p>
        <p class="link-vcu-file-label">{{ 'arquivos.shareHint' | transloco }}</p>
      </ng-container>
    </div>
  </p-dialog>

  <p-dialog
    [header]="'arquivos.moveHeader' | transloco"
    [(visible)]="moveDialogVisible"
    [modal]="true"
    [style]="{ width: '90vw', 'max-width': '520px' }"
    [closable]="!moving"
  >
    <div class="move-dialog-body">
      <p class="link-vcu-file-label">
        {{ 'arquivos.moveCount' | transloco: { count: moveItems.length } }}
      </p>

      <div class="upload-type-row">
        <div class="upload-type-item" (click)="!moving && (moveFolderChoice = 'root')">
          <p-radioButton name="moveFolderChoice" value="root" [(ngModel)]="moveFolderChoice"
                         inputId="moveFolderRoot" [disabled]="moving" />
          <label for="moveFolderRoot" class="upload-type-label">
            <i class="pi pi-home"></i>
            {{ 'arquivos.uploadFolderRoot' | transloco }}
          </label>
        </div>
        <div class="upload-type-item" *ngIf="availableFolders.length"
             (click)="!moving && (moveFolderChoice = 'existing')">
          <p-radioButton name="moveFolderChoice" value="existing" [(ngModel)]="moveFolderChoice"
                         inputId="moveFolderExisting" [disabled]="moving" />
          <label for="moveFolderExisting" class="upload-type-label">
            <i class="pi pi-folder"></i>
            {{ 'arquivos.uploadFolderExisting' | transloco }}
          </label>
        </div>
        <div class="upload-type-item" (click)="!moving && (moveFolderChoice = 'custom')">
          <p-radioButton name="moveFolderChoice" value="custom" [(ngModel)]="moveFolderChoice"
                         inputId="moveFolderCustom" [disabled]="moving" />
          <label for="moveFolderCustom" class="upload-type-label">
            <i class="pi pi-folder-plus"></i>
            {{ 'arquivos.uploadFolderOther' | transloco }}
          </label>
        </div>
      </div>

      <div *ngIf="moveFolderChoice === 'existing'" class="folder-list">
        <div *ngFor="let folder of availableFolders" class="folder-list-item"
             [class.selected]="moveExistingFolder === folder"
             (click)="!moving && (moveExistingFolder = folder)">
          <p-radioButton name="moveExistingFolder" [value]="folder"
                         [(ngModel)]="moveExistingFolder" [inputId]="'move-' + folder"
                         [disabled]="moving" />
          <label [for]="'move-' + folder" class="folder-list-label">
            <i class="pi pi-folder"></i> {{ folder }}
          </label>
        </div>
      </div>

      <input *ngIf="moveFolderChoice === 'custom'" type="text" pInputText class="rename-input"
             [(ngModel)]="moveCustomFolder" [disabled]="moving"
             [attr.placeholder]="'arquivos.moveFolderPlaceholder' | transloco" />
    </div>
    <ng-template pTemplate="footer">
      <p-button [label]="'common.buttons.cancel' | transloco" [text]="true"
                [disabled]="moving" (onClick)="moveDialogVisible = false" />
      <p-button [label]="'arquivos.moveConfirm' | transloco" [loading]="moving"
                [disabled]="!canConfirmMove" (onClick)="confirmMove()" />
    </ng-template>
  </p-dialog>

